import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultSingleItemPickerDisplayText, singleItemPickerDisplayTextValidatorSchema } from '../../../single-item-picker/types/display-text';
/**
 * Default display text for the 3D Glasses Picker component.
 */
export const defaultThreeDGlassesPickerDisplayText = Object.assign(Object.assign({}, defaultSingleItemPickerDisplayText), { headerLabel: 'Add-ons' });
export const threeDGlassesPickerDisplayTextValidator = Validator.object(Object.assign(Object.assign({}, singleItemPickerDisplayTextValidatorSchema), { headerLabel: nonEmptyStringValidator }));
